// extracted by mini-css-extract-plugin
export const heading = "header-module--heading--12dxW";